// extracted by mini-css-extract-plugin
export default {"recos":"f2-z","productCardOverride":"g2-z","rowHasBadge":"h2-z"};